/** @jsx jsx */
import PropTypes from "prop-types"
import { Grid, jsx, Styled } from "theme-ui"

export default function ListItem({ icon, text, title }) {
  return (
    <Grid
      columns={["40px 1fr", null, "40px 1fr"]}
      sx={{
        columnGap: 5,
        justifyItems: ["left", null, "flex-start"],
        rowGap: 1,
        img: {
          gridRow: "span 2",
        },
      }}
    >
      <img
        alt={icon?.altText}
        src={icon?.file?.url}
        sx={{ height: "40px", width: "40px" }}
      />
      <h3 sx={{ variant: "caption" }}>{title}</h3>
      <Styled.p sx={{ textAlign: ["left", null, "left"] }}>
        {text.text}
      </Styled.p>
    </Grid>
  )
}

ListItem.propTypes = {
  icon: PropTypes.shape({
    altText: PropTypes.string,
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  text: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
}
